/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'townsquare.townsquare-tags.tag': 'Supprimer le tag',
  'townsquare.townsquare-tags.tooltip-usage-count':
    '{usageCount, plural, one {Utilisé à {usageCount,number} endroit} other {Utilisé à {usageCount,number} endroits}}',
};
